import { MessagesMessage } from 'primereact/messages';

import { ToastLife } from '@/components/hoc/toast-container/enums';

export enum ToastActions {
  ADD_TOAST = 'toast/ADD_TOAST',
  REMOVE_TOAST = 'toast/REMOVE_TOAST',
  CLEAR_TOASTS = 'toast/CLEAR_TOASTS',
}

export type ToastType = {
  messages: MessagesMessage[];
};

export const initialState: ToastType = {
  messages: [],
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case ToastActions.ADD_TOAST:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };
    case ToastActions.REMOVE_TOAST:
      return {
        ...state,
        messages: state.messages.filter((_, index) => index !== action.payload),
      };
    case ToastActions.CLEAR_TOASTS:
      return {
        ...state,
        messages: [],
      };
    default:
      return state;
  }
}

// Action creators
export const addToast = (
  message: Omit<MessagesMessage, 'life'> & { life?: number },
) => ({
  type: ToastActions.ADD_TOAST,
  payload: {
    ...message,
    life: message.life || ToastLife.DEFAULT,
  },
});

export const removeToast = (index: number) => ({
  type: ToastActions.REMOVE_TOAST,
  payload: index,
});

export const clearToasts = () => ({
  type: ToastActions.CLEAR_TOASTS,
});
